// import { behavior as stickyBehavior } from './src/components/Sticky'
// const stickyBehavior = require('./src/components/Sticky').behavior

const baseURL =
  'https://global.americanexpress.com/acq/intl/dpa/emea/aut/pers/begin.do'



const tracking = {

  'blue': {
    static: {
      perform: 'IntlEapp:AUT:bluev2',
    },
    cpid: '100473516',
    sourcesuffix: {
      default: 'A03201600',
    },
  },
  'blue-mr': {
    static: {
      perform: 'IntlEapp:AUT:bluev2',
    },
    cpid: '100473515',
    sourcesuffix: {
      default: 'A03191600',
    },
  },
  'blue-aff': {
    static: {
      perform: 'IntlEapp:AUT:bluev2',
    },
    cpid: '200000000',
    sourcesuffix: {
      default: 'A0000FCHYX',
    },
  },
  'blue-mr-aff': {
    static: {
      perform: 'IntlEapp:AUT:bluev2',
    },
    cpid: '200000000',
    sourcesuffix: {
      default: 'A0000FCHYX',
    },
  },
  'gold': {
    static: {
      perform: 'IntlEapp:AUT:gold',
    },
    cpid: '100589614',
    sourcesuffix: {
      default: 'D03254012',
    },
  },
  'gold-aff': {
    static: {
      perform: 'IntlEapp:AUT:gold',
    },
    cpid: '100587646',
    sourcesuffix: {
      default: 'D03254014',
    },
  },
  'platinum': {
    static: {
      perform: 'IntlEapp:AUT:platinum',
    },
    cpid: '100510364',
    sourcesuffix: {
      default: 'E03235014',
    }
  },
  'platinum-aff': {
    static: {
      perform: 'IntlEapp:AUT:platinum',
    },
    cpid: '100510496',
    // multicode: 'E03215216',
    sourcesuffix: {
      default: 'E03235017',
    }
  },
}

/*
const behaviors = {
  sticky: stickyBehavior,
}

function querySelectorAll(selector, context = document) {
  return Array.prototype.slice.call(context.querySelectorAll(selector))
}

const withEls = (selector, cb) => querySelectorAll(selector).forEach(cb)

const onLoad = () => {
  withEls('[data-js]:not([data-js-attached])', el => {
    const type = el.getAttribute('data-js')
    if (behaviors[type] && behaviors[type].attach) {
      const detach = behaviors[type].attach(el)
      if (!behaviors[type].detach && typeof detach === 'function') {
        behaviors[type].detach = detach
      }
      el.setAttribute('data-js-attached', true)
    }
  })
}

const onUnload = () => {
  withEls('[data-js-attached]', el => {
    const type = el.getAttribute('data-js')
    if (behaviors[type] && behaviors[type].detach) {
      behaviors[type].detach(el)
    }
    el.removeAttribute('data-js-attached')
  })
}

exports.onInitialClientRender = () => onLoad()

exports.shouldUpdateScroll = () => {
  onUnload()
  onLoad()
}
*/

exports.onClientEntry = async () => {
  require('gsap')
  require('scrollmagic')
  require('animation.gsap')

  if (typeof IntersectionObserver === `undefined`) {
    await import(`intersection-observer`);
    //console.log(`# IntersectionObserver is polyfilled!`)
  }

  if (process.env.NODE_ENV === 'development') {
    // require('scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min.js')
  }

  window.cta = {
    baseURL,
    tracking,
  }
}
